import React, { useCallback, useState, useRef } from 'react';
import { prop } from 'ramda';
import { Icon } from '@core/js/components/common/Icon';
import { AccessibilityElement } from '@core/js/components/common/AccessibilityElement';
import { useDeviceSelector } from '@core/js/store/hooks';
import { AccountPanel } from './components/AccountPanel';

import { useOutsideClick } from './helpers';
import { TDropdownAccountProps } from './types';
import style from './DropdownAccount.scss';

export const DropdownAccount: React.FC<TDropdownAccountProps> = ({
    headerHeight = 0
}) => {
    const isMobile = useDeviceSelector(prop('isMobile'));
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const { openManually } = useOutsideClick(dropdownRef, () => setIsOpen(false));

    const onClick = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        openManually();
        setIsOpen(prev => !prev);

        event.stopPropagation();
    }, [openManually]);

    return (
        <span ref={dropdownRef} className={style.dropdownAccount}>
            <AccessibilityElement onClick={onClick} className={style.dropdownAccountIcon}>
                {!isMobile && (
                    <Icon
                        type={isOpen ? 'headerUserIconActive' : 'headerUserIcon'}
                        className={`${style.icon} ${isOpen ? 'cms-dropdown-user-icon-active' : 'cms-dropdown-user-icon'}`}
                    />
                )}
                {isMobile && (
                     <Icon
                        type={isOpen ? 'headerUserIconMobileActive' : 'headerUserIconMobile'}
                        className={`${style.icon} ${isOpen ? 'cms-dropdown-user-icon-active' : 'cms-dropdown-user-icon'}`}
                    />
                )}
            </AccessibilityElement>

            {isOpen && <AccountPanel headerHeight={headerHeight} />}
        </span>
    );
};
